import { Store } from 'vuex';
import { RootState } from '../types';
import { GSP_MODULE_CACHE_CONFIG } from '@/shared/config/cache';
import router from '@/router';

let refreshInterval: number | null = null; // <-- Fix: use 'number'

export function cacheRefreshPlugin(store: Store<RootState>) {
  // Clear previous interval if exists (prevents duplicates during Webpack hot-reload in dev)
  if (refreshInterval) {
    clearInterval(refreshInterval);
  }

// Start the interval immediately
  refreshInterval = setInterval(() => {
    /* Checking router inside the callback ensures:
       1. The router is fully initialized.
       2. We check the CURRENT route at every tick, 
          so it stops/starts working if the user moves between pages.
    */
    const isGspRequired = router?.currentRoute?.meta?.requiresGsp;

    if (isGspRequired) {
      console.log('Refreshing GSP Modules for active route...');
      store.dispatch('gspModule/getGspModules', { force: true });
    }
  }, GSP_MODULE_CACHE_CONFIG.DURATION);




  // Cleanup when store is destroyed (rare, but good practice)
  // window.addEventListener('beforeunload', () => {
  //   if (refreshInterval) clearInterval(refreshInterval);
  // });
}